export default __webpack_public_path__ + "static/media/banner1.4c55b8cb.jpg";